import React from 'react'
import shareButton from 'assets/images/shareButton.svg'

// Assets
import Loading from 'assets/images/loading-white.svg'

interface PrimaryButtonProps {
  buttonText: string | JSX.Element
  primaryButtonFunction?: () => void
  isDisabled?: boolean
  isLoading?: boolean
  outlined?: boolean
  isShare?: boolean
  margins?: string
  type?: 'submit' | 'reset' | 'button'
  className?: string
  dataTestId?: string
}

const PrimaryButton = ({
  buttonText,
  primaryButtonFunction = () => null,
  isDisabled = false,
  isLoading = false,
  outlined = false,
  isShare = false,
  margins = '',
  type = 'button',
  className = '',
  dataTestId = ''
}: PrimaryButtonProps) => (
  <button
    data-testid={dataTestId}
    type={type}
    className={`flex justify-center items-center antialiased rounded-full w-full h-12 self-center ${margins} font-bold focus:outline-none focus-visible:ring-4 ${
      !!isDisabled && 'opacity-40 pointer-events-none'
    } transition-all hover:bg-green-800 active:bg-green-900 ${
      outlined
        ? 'bg-white text-purple-900 focus-visible:ring-btnRingColor/10 border border-purple-900 hover:text-white hover:border-none'
        : 'bg-purple-900 text-white focus-visible:ring-btnRingColor/25 '
    } ${className}`}
    onClick={() => primaryButtonFunction()}
    disabled={isDisabled || isLoading}
  >
    {isShare && (
      <img
        className='absolute left-3 w-6 md:hidden ml-4 h-6'
        src={shareButton}
        alt=''
      />
    )}
    {isLoading && !outlined ? (
      <img className='h-12 w-12' src={Loading} alt='Cargando' />
    ) : (
      <p>{buttonText}</p>
    )}
  </button>
)

export default PrimaryButton
